import PaymentErrorBoundary from 'components/payment/payment-error-boundary/payment-error-boundary.component';
import { useSpreedlyHosted } from '../spreedly-payment-hosted.hooks';
import SpreedlyPaymentHostedWrapper from '../spreedly-payment-hosted-wrapper.component';
import SpredlyPaymentHostedForm from '../spreedly-payment-hosted-form/spreedly-payment-hosted-form.component';

// useSpreedlyHosted() throws on a script-loading failure (see its own
// comment) — it has to run inside PaymentErrorBoundary's subtree, not in the
// component that renders the boundary itself, or the throw would escape
// uncaught.
const SpreedlyPaymentPageHostedContent = () => {
  const {
    initOrderResponse,
    loading,
    spreedlyScriptLoading,
    refetchInitOrder,
  } = useSpreedlyHosted();

  return (
    <SpreedlyPaymentHostedWrapper isLoading={spreedlyScriptLoading}>
      {!!initOrderResponse && (
        <SpredlyPaymentHostedForm
          initOrderResponse={initOrderResponse}
          refetchInitOrder={refetchInitOrder}
          loading={loading}
        />
      )}
    </SpreedlyPaymentHostedWrapper>
  );
};

const SpreedlyPaymentPageHosted = () => {
  return (
    <PaymentErrorBoundary name="spreedly-payment-page-hosted">
      <SpreedlyPaymentPageHostedContent />
    </PaymentErrorBoundary>
  );
};

export default SpreedlyPaymentPageHosted;
